import { render, staticRenderFns } from "./retur-set-price-table-filter.vue?vue&type=template&id=4184557d&"
import script from "./retur-set-price-table-filter.vue?vue&type=script&lang=js&"
export * from "./retur-set-price-table-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports